"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vuex = require("vuex");

var _LineChart = _interopRequireDefault(require("../components/v2charts/LineChart"));

var _BarChart = _interopRequireDefault(require("../components/v2charts/BarChart"));

var _BarChartHorizontal = _interopRequireDefault(require("../components/v2charts/BarChartHorizontal"));

var _v = _interopRequireDefault(require("../components/Top10List/v2"));

var _CardInfoV = _interopRequireDefault(require("@/views/dashboard/components/CardInfo/Admin/CardInfoV3"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "admin-v3",
  components: {
    LineChart: _LineChart.default,
    BarChart: _BarChart.default,
    BarChartHorizontal: _BarChartHorizontal.default,
    Top10List: _v.default,
    CardInfo: _CardInfoV.default
  },
  props: {
    cardData: Object,
    sevenDays: Object,
    channelLabels: Array,
    channelValues: Array,
    topRate: Array,
    topRatePercent: Array,
    topRateLabels: Array,
    bottomRate: Array,
    bottomRatePercent: Array,
    bottomRateLabels: Array,
    topOrgs: Array,
    topAgents: Array,
    loading: Boolean,
    lineGraphLabel: Array,
    sevenDaysNotEmpty: Boolean,
    successDate: String,
    failDate: String,
    channelDate: String,
    numberOfDecimal: Boolean
  },
  computed: {
    cardInfo: function cardInfo() {
      return [{
        icon: {
          style: 'font-size: 4em; color: Gold;',
          class: 'fas fa-clipboard-check',
          color: 'success',
          icon: 'checked'
        },
        text: this.$t('dashboard.queryApiTimes'),
        count: {
          endVal: parseInt(this.cardData.totalPayAmount[0].totalCountQueryApi),
          decimal: false
        }
      }, {
        icon: {
          style: 'font-size: 4em; color: DarkTurquoise;',
          class: 'fas fa-handshake',
          color: 'warning',
          icon: 'inbox'
        },
        text: this.$t('dashboard.totalPayAmount'),
        count: {
          endVal: parseFloat(this.cardData.totalPayAmount[0].processTotalSumMoneyFrom),
          decimal: true
        }
      }, {
        icon: {
          style: 'font-size: 4em; color: DarkKhaki;',
          class: 'fas fa-clock',
          color: 'danger',
          icon: 'emails'
        },
        text: this.$t('dashboard.waitForSubmitting'),
        count: {
          endVal: parseInt(this.cardData.waitForSubmitting),
          decimal: false
        }
      }, {
        icon: {
          style: 'font-size: 4em; color: SeaGreen;',
          class: 'fas fa-money-bill-alt',
          color: 'info',
          icon: 'coin'
        },
        text: this.$t('dashboard.rechargeAmount'),
        count: {
          endVal: parseInt(this.cardData.rechargeAmount),
          decimal: true,
          numberOfDecimal: this.numberOfDecimal
        }
      }];
    }
  }
};
exports.default = _default;